var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-title',{attrs:{"color":false,"title":'Home Challenge'}}),_c('select-child',{attrs:{"users":_vm.getChildrenData,"router":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }